<style type="text/css" media="print">
    @page { size: portrait; }
  </style>

  <div ng-if="!application.length" class="title-recomendacoes">
    <h5>Nenhuma aplicação pendente neste período</h5>
  </div>
  <div ng-repeat="aplicacao in application" class="only-print" id="print-aplicacao-{{application.id}}">
    <div class="title-recomendacoes">
        <h5>{{aplicacao.tipo_operacao | capitalize}}</h5>
    </div>
    <br>
    <p>
      <strong>Iniciada em: </strong>
      {{aplicacao.auditoria_aplicacao.dt_ini | date:'shortDate'}}
      <br>
      <strong>Encerrada em: </strong>
      {{aplicacao.auditoria_aplicacao.dt_fim | date:'shortDate'}}
      <br>
    </p>
    <strong>Operador: </strong>{{aplicacao.usuario.nome | uppercase}}
    <br>
    <strong>Propriedade: </strong>{{aplicacao.propriedade.descricao | uppercase}}
    <br>
    <div ng-if="aplicacao.gleba.id">
      <strong>Talhão: </strong>{{aplicacao.gleba.descricao | uppercase}} ({{aplicacao.gleba.area | number: 2}} ha)
      <span class="side-space"></span>
    </div>
    <strong>Cultura: </strong>{{aplicacao.cultura.descricao | uppercase}}
    <span class="side-space"></span>
    <span class="side-space"></span>
    <div ng-if="aplicacao.gleba.id">
      <strong>Área Total: </strong>{{aplicacao.auditoria_aplicacao.area | number: 2}} ha
    </div>

    <table class="table no-padding recomendacao">
      <thead ng-if="aplicacao.sementes">
        <tr>
          <th class="no-padding-left col-xs-4">Semente Origem</th>
          <th class="text-right col-xs-3">Semente Destino</th>
          <th class="text-right col-xs-3">Total</th>
        </tr>
      </thead>
      <tbody ng-if="aplicacao.sementes">
        <tr>
        <td class="no-padding-left col-xs-4 vertical-middle">{{aplicacao.sementes.origem.descricao}}</td>
        <td class="text-right col-xs-4 vertical-middle">{{aplicacao.sementes.destino.descricao || '--'}} </td>
        <td class="text-right col-xs-3 vertical-middle">{{aplicacao.sementes.origem.tratado.quantidade | formatDynamicDecimals}} {{aplicacao.sementes.origem.tratado.abreviatura}}</td>
      </tr></tbody>
    </table>
    <table class="table no-padding recomendacao">
      <thead>
        <tr>
          <th class="no-padding-left col-xs-4">Produto</th>
          <th class="text-right col-xs-3">Dose</th>
          <th class="text-right col-xs-3">Total</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="produto in aplicacao.produtos">
          <td class="no-padding-left col-xs-4 vertical-middle">{{produto.descricao}}<br>{{produto.lote.nrLote}}</td>
          <td class="text-right col-xs-4 vertical-middle">{{produto.dose | formatDynamicDecimals}} {{produto.unidade.abreviatura}}/{{aplicacao.sementes.origem.tratado.abreviatura ? '100' + aplicacao.sementes.origem.tratado.abreviatura : 'ha'}}</td>
          <td class="text-right col-xs-3 vertical-middle">{{produto.quantidadeTotal | formatDynamicDecimals}} {{produto.unidade.abreviatura}}</td>
        </tr>
      </tbody>
    </table>
    <p class="list-group-item-text" ng-show="aplicacao.atributo.capacidade_tanque">
      <strong>Capacidade Tanque: </strong>{{aplicacao.atributo.capacidade_tanque | number:2}} l
    </p>
    <p class="list-group-item-text" ng-show="aplicacao.atributo.velocidade_maxima_vento">
      <strong>Vento: </strong>{{aplicacao.atributo.velocidade_maxima_vento | number:0}} km/h
    </p>
    <p class="list-group-item-text" ng-show="aplicacao.atributo.umidade_inicial">
      <span ng-show="aplicacao.atributo.umidade_inicial">
        <strong>Umidade: </strong>{{aplicacao.atributo.umidade_inicial | number:0}}%
      </span>
    </p>
    <p class="list-group-item-text" ng-show="aplicacao.atributo.temperatura_inicial">
      <span ng-show="aplicacao.atributo.temperatura_inicial">
        <strong>Temperatura: </strong>{{aplicacao.atributo.temperatura_inicial | number:0}}°C
      </span>
    </p>
    <p class="list-group-item-text" ng-show="aplicacao.atributo.horas_sem_chuva">
      <strong>{{aplicacao.atributo.horas_sem_chuva | number:0}} horas</strong> sem chuva
    </p>
    <p class="list-group-item-text" ng-show="aplicacao.auditoria_aplicacao.obs || aplicacao.auditoria_aplicacao.observacoes">
      <strong>Observação: </strong> {{aplicacao.auditoria_aplicacao.obs ||  aplicacao.auditoria_aplicacao.observacoes}}
    </p>
    <br><br>
  </div>
